import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc5f0fdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div id=\"scene\" class=\"scene\" data-hover-only=\"false\" data-v-cc5f0fdc><div class=\"circle\" data-depth=\"1.2\" data-v-cc5f0fdc></div><div class=\"one\" data-depth=\"0.9\" data-v-cc5f0fdc><div class=\"content\" data-v-cc5f0fdc><span class=\"piece\" data-v-cc5f0fdc></span><span class=\"piece\" data-v-cc5f0fdc></span><span class=\"piece\" data-v-cc5f0fdc></span></div></div><div class=\"two\" data-depth=\"0.60\" data-v-cc5f0fdc><div class=\"content\" data-v-cc5f0fdc><span class=\"piece\" data-v-cc5f0fdc></span><span class=\"piece\" data-v-cc5f0fdc></span><span class=\"piece\" data-v-cc5f0fdc></span></div></div><div class=\"three\" data-depth=\"0.40\" data-v-cc5f0fdc><div class=\"content\" data-v-cc5f0fdc><span class=\"piece\" data-v-cc5f0fdc></span><span class=\"piece\" data-v-cc5f0fdc></span><span class=\"piece\" data-v-cc5f0fdc></span></div></div><p class=\"p404\" data-depth=\"0.50\" data-v-cc5f0fdc> 403 </p><p class=\"p404\" data-depth=\"0.10\" data-v-cc5f0fdc> 403 </p></div>", 1)
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Uh oh! 看起来你没有任何可以访问的权限，联系你的管理员为你添加吧！", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前页面你没有权限访问！ ", -1))

import { useAppStore } from '@/store'
import { clearToken } from '@/utils'
import { useRouter } from 'vue-router'
import { onMounted } from 'vue'
import Parallax from 'parallax-js'


export default /*#__PURE__*/_defineComponent({
  __name: '403',
  setup(__props) {

const app = useAppStore()
const router = useRouter()

onMounted(() => {
  const scene = document.getElementById('scene')
  if (scene) {
    const parallaxInstance = new Parallax(scene)
    console.log(parallaxInstance)
  }
})

function toLogin () {
  clearToken()
  router.push('/login')
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_unref(app).authList.length===0)
          ? (_openBlock(), _createElementBlock("article", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_a_button, { onClick: toLogin }, {
                default: _withCtx(() => [
                  _createTextVNode(" 切换账号 ")
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("article", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 返回首页 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, { onClick: toLogin }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 切换账号 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
      ])
    ])
  ]))
}
}

})